export const GET_END_POINT_DEFINITIONS = "GET_END_POINT_DEFINITIONS"
export const GET_END_POINT_DEFINITIONS_SUCCESS = "GET_END_POINT_DEFINITIONS_SUCCESS"
export const GET_END_POINT_DEFINITIONS_FAIL = "GET_END_POINT_DEFINITIONS_FAIL"


export const ADD_END_POINT_DEFINITION = "ADD_END_POINT_DEFINITION"
export const ADD_END_POINT_DEFINITION_SUCCESS = "ADD_END_POINT_DEFINITION_SUCCESS"
export const ADD_END_POINT_DEFINITION_FAIL = "ADD_END_POINT_DEFINITION_FAIL"

export const UPDATE_END_POINT_DEFINITION = "UPDATE_END_POINT_DEFINITION"
export const UPDATE_END_POINT_DEFINITION_SUCCESS = "UPDATE_END_POINT_DEFINITION_SUCCESS"
export const UPDATE_END_POINT_DEFINITION_FAIL = "UPDATE_END_POINT_DEFINITION_FAIL"

export const DELETE_END_POINT_DEFINITION = "DELETE_END_POINT_DEFINITION"
export const DELETE_END_POINT_DEFINITION_SUCCESS = "DELETE_END_POINT_DEFINITION_SUCCESS"
export const DELETE_END_POINT_DEFINITION_FAIL = "DELETE_END_POINT_DEFINITION_FAIL"

export const API_ERROR = "API_ERROR"
